/// Menu
import React, { useContext, useEffect, useReducer, useState } from "react";
import Collapse from "react-bootstrap/Collapse";

/// Link
import { Link } from "react-router-dom";

// import {MenuList} from './Menu';
// import { MenuList } from "./MenuLIMS";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { useSelector } from "react-redux";
import { SVGICON } from "../../constant/theme";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBarLIMS = () => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  useEffect(() => {}, []);
  //For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll],
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };
  // Menu dropdown list End

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;
  // const sideMenu = useSelector((state) => state.sideMenu);

  return (
    <div
      className={`deznav  border-right ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <div className="deznav-scroll">
        <ul className="metismenu p-0" id="menu">
          {/* START: HOME */}
          {AuthUser?.UserType == 4 || AuthUser?.UserType == 1 ? (
            <li
              className={` ${state?.active === "Home" ? "mm-active" : ""}`}
              key={1}
            >
              <Link
                to="dashboard"
                onClick={() => {
                  handleMenuActive("Home");
                }}
              >
                <div className="menu-icon">{SVGICON.Home}</div>{" "}
                <span className="nav-text">Home</span>
              </Link>
            </li>
          ) : (
            <></>
          )}
          {AuthUser?.UserType !== 4 &&
          AuthUser?.UserType !== 1 &&
          AuthUser?.UserType !== 2 ? (
            <li
              className={` ${state?.active === "Home" ? "mm-active" : ""}`}
              key={1}
            >
              <Link
                to="home"
                onClick={() => {
                  handleMenuActive("Home");
                }}
              >
                <div className="menu-icon">{SVGICON.Home}</div>{" "}
                <span className="nav-text">Home</span>
              </Link>
            </li>
          ) : (
            <></>
          )}
          {AuthUser?.UserType == 2 ? (
            <>
              <li
                className={`${state?.active === "Inward" ? "mm-active" : ""}`}
                key={1}
              >
                <Link
                  to="/customer-inward"
                  onClick={() => {
                    handleMenuActive("Inward");
                  }}
                >
                  <div className="menu-icon">{SVGICON.ProjectsSidbar}</div>
                  <span className="nav-text">Inward</span>
                </Link>
              </li>
              {AuthUser?.UserType == 2 && AuthUser?.IsInvoice == true ? (
                <li
                  className={` ${
                    state?.active === "Invoice" ? "mm-active" : ""
                  }`}
                  key={2}
                >
                  <Link
                    to="/customer-invoice"
                    onClick={() => {
                      handleMenuActive("Invoice");
                    }}
                  >
                    <div className="menu-icon">{SVGICON.Finance}</div>
                    <span className="nav-text">Invoices </span>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {AuthUser?.UserType == 2 && AuthUser?.IsLedger == true ? (
                <li
                  className={` ${
                    state?.active === "Ledger" ? "mm-active" : ""
                  }`}
                  key={3}
                >
                  <Link
                    to="/customer-ledger-report"
                    onClick={() => {
                      handleMenuActive("Ledger");
                    }}
                  >
                    <div className="menu-icon">{SVGICON.GridDots}</div>
                    <span className="nav-text">Ledger </span>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {AuthUser?.UserType == 2 && AuthUser?.IsOutstanding == true ? (
                <li
                  className={` ${
                    state?.active === "Outstanding" ? "mm-active" : ""
                  }`}
                  key={4}
                >
                  <Link
                    to="/customer-outstanding-report"
                    onClick={() => {
                      handleMenuActive("Outstanding");
                    }}
                  >
                    <div className="menu-icon">{SVGICON.Widget}</div>
                    <span className="nav-text">Outstanding </span>
                  </Link>
                </li>
              ) : (
                ""
              )}
            </>
          ) : (
            <></>
          )}
          {/* END: HOME */}

          {/* START: Companies */}
          {AuthUser?.UserType == 5 ? (
            <li
              className={` ${state?.active === "Companies" ? "mm-active" : ""}`}
              key={0}
            >
              <Link
                to="companies"
                onClick={() => {
                  handleMenuActive("Companies");
                }}
              >
                <div className="menu-icon">{SVGICON.User}</div>{" "}
                <span className="nav-text">Companies</span>
              </Link>
            </li>
          ) : (
            <></>
          )}
          {/* END: Companies */}

          {/* START: System Setup */}
          {(AuthUser?.UserType == 4 &&
            formsList?.filter((x) => x.FormID == 9)?.length > 0) ||
          (AuthUser?.UserType == 1 &&
            formsList?.filter(
              (x) =>
                (x?.FormID == 7 ||
                  x?.FormID == 8 ||
                  x?.FormID == 9 ||
                  x?.FormID == 10 ||
                  x?.FormID == 11 ||
                  x?.FormID == 12 ||
                  x?.FormID == 13 ||
                  x?.FormID == 61 ||
                  x?.FormID == 81 ||
                  x?.FormID == 95 ||
                  x?.FormID == 94 ||
                  x?.FormID == 96 ||
                  x?.FormID == 97 ||
                  x?.FormID == 83) &&
                (x?.IsRead ||
                  x?.IsAdd ||
                  x?.IsEdit ||
                  x?.IsActive ||
                  x?.IsDelete ||
                  x?.IsExport),
            )?.length > 0) ? (
            <li
              className={` ${
                state?.active === "System Setup" ? "mm-active" : ""
              }`}
              key={2}
            >
              <Link
                to={"#"}
                className="has-arrow"
                onClick={() => {
                  handleMenuActive("System Setup");
                }}
              >
                <div className="menu-icon">{SVGICON.Widget}</div>{" "}
                <span className="nav-text">System Setup</span>
              </Link>
              <Collapse in={state?.active === "System Setup" ? true : false}>
                <ul className="mm-show">
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 7 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={7}
                      className={`${
                        state?.activeSubmenu === "Categories" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="categories"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Categories");
                        }}
                      >
                        Categories
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 8 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={8}
                      className={`${
                        state?.activeSubmenu === "Voucher Series"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="voucher-series"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Voucher Series");
                        }}
                      >
                        Voucher Series
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {(AuthUser?.UserType == 4 &&
                    formsList?.filter((x) => x.FormID == 9)?.length > 0) ||
                  (AuthUser?.UserType == 1 &&
                    formsList?.filter(
                      (x) =>
                        x?.FormID == 9 &&
                        (x?.IsRead ||
                          x?.IsAdd ||
                          x?.IsEdit ||
                          x?.IsActive ||
                          x?.IsDelete ||
                          x?.IsExport),
                    )?.length > 0) ? (
                    <li
                      key={9}
                      className={`${
                        state?.activeSubmenu === "Employees" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="employee"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Employees");
                        }}
                      >
                        Employees
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 10 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={10}
                      className={`${
                        state?.activeSubmenu === "Customer" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="customer"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Customer");
                        }}
                      >
                        Customer
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/*
                    {AuthUser?.UserType == 1 &&
                    formsList?.filter(
                      (x) =>
                        x?.FormID == 11 &&
                        (x?.IsRead ||
                          x?.IsAdd ||
                          x?.IsEdit ||
                          x?.IsActive ||
                          x?.IsDelete ||
                          x?.IsExport)
                    )?.length > 0 ? (
                      <li
                      key={11}
                      className={`${
                        state?.activeSubmenu === "Merge Customer"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="#"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Merge Customer");
                        }}
                      >
                        Merge Customer
                      </Link>
                    </li>
                    ):(<></>)}
                     */}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 12 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={12}
                      className={`${
                        state?.activeSubmenu === "Vendor" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="vendor"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Vendor");
                        }}
                      >
                        Vendor
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 13 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={13}
                      className={`${
                        state?.activeSubmenu === "Courier" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="courier"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Courier");
                        }}
                      >
                        Courier
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Email == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 61 && (x?.IsRead || x?.IsAdd || x?.IsEdit),
                  )?.length > 0 ? (
                    <li
                      key={61}
                      className={`${
                        state?.activeSubmenu === "Email Configuration"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/email-configuration"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Email Configuration");
                        }}
                      >
                        Email Configuration
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Whatsup == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 81 && (x?.IsRead || x?.IsAdd || x?.IsEdit),
                  )?.length > 0 ? (
                    <li
                      key={81}
                      className={`${
                        state?.activeSubmenu === "WhatsApp Configuration"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/whatsapp-configuration"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("WhatsApp Configuration");
                        }}
                      >
                        WhatsApp Configuration
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 83 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={83}
                      className={`${
                        state?.activeSubmenu === "Company LUT Document"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="company-lut-document"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Company LUT Document");
                        }}
                      >
                        Company LUT Document
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.NDT == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 95 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={95}
                      className={`${
                        state?.activeSubmenu === "Films" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="films"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Films");
                        }}
                      >
                        Films
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.NDT == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 94 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={94}
                      className={`${
                        state?.activeSubmenu === "NDT Category"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="ndt-categories"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("NDT Category");
                        }}
                      >
                        NDT Category
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.NDT == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 96 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={96}
                      className={`${
                        state?.activeSubmenu === "Camera" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="camera"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("Camera");
                        }}
                      >
                        Camera
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.NDT == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 97 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={97}
                      className={`${
                        state?.activeSubmenu === "Supplier" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="supplier"
                        onClick={() => {
                          handleMenuActive("Supplier");
                          handleSubmenuActive("Supplier");
                        }}
                      >
                        Supplier
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.NDT == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 104 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={104}
                      className={`${
                        state?.activeSubmenu === "NDTMaterial"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="ndtmaterial"
                        onClick={() => {
                          handleMenuActive("System Setup");
                          handleSubmenuActive("NDTMaterial");
                        }}
                      >
                        NDT Material
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                </ul>
              </Collapse>
            </li>
          ) : (
            <></>
          )}
          {/* END: System Setup */}

          {/* START: Configuration */}
          {AuthUser?.UserType == 1 &&
          formsList?.filter(
            (x) =>
              (x?.FormID == 16 ||
                x?.FormID == 17 ||
                x?.FormID == 18 ||
                x?.FormID == 19 ||
                x?.FormID == 20 ||
                x?.FormID == 21 ||
                x?.FormID == 22 ||
                x?.FormID == 23 ||
                x?.FormID == 24 ||
                x?.FormID == 25 ||
                x?.FormID == 26) &&
              (x?.IsRead ||
                x?.IsAdd ||
                x?.IsEdit ||
                x?.IsActive ||
                x?.IsDelete ||
                x?.IsExport),
          )?.length > 0 ? (
            <li
              className={` ${
                state?.active === "Configuration" ? "mm-active" : ""
              }`}
              key={3}
            >
              <Link
                to={"#"}
                className="has-arrow"
                onClick={() => {
                  handleMenuActive("Configuration");
                }}
              >
                <div className="menu-icon">{SVGICON.Table}</div>{" "}
                <span className="nav-text">Configuration</span>
              </Link>
              <Collapse in={state?.active === "Configuration" ? true : false}>
                <ul className="mm-show">
                  {/* START: Material Configuration */}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      (x?.FormID == 17 ||
                        x?.FormID == 18 ||
                        x?.FormID == 19 ||
                        x?.FormID == 20 ||
                        x?.FormID == 21 ||
                        x?.FormID == 22 ||
                        x?.FormID == 23 ||
                        x?.FormID == 24) &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={14}
                      className={`${
                        state?.activeSubmenu === "Material Configuration"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="has-arrow"
                        onClick={() => {
                          // handleMenuActive("Configuration");
                          handleSubmenuActive("Material Configuration");
                        }}
                      >
                        Material Configuration
                      </Link>
                      <Collapse
                        in={
                          state?.activeSubmenu === "Material Configuration"
                            ? true
                            : false
                        }
                      >
                        <ul className="mm-show">
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 17 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={17}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "material-categories"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="material-categories"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Material Categories
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 18 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={18}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "departments" ? "mm-active" : ""
                                }`}
                                to="departments"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Departments
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 19 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={19}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "product-groups" ? "mm-active" : ""
                                }`}
                                to="product-groups"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Material Group
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 20 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={20}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "test-method" ? "mm-active" : ""
                                }`}
                                to="test-method"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Test Method
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 21 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={21}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "parameters" ? "mm-active" : ""
                                }`}
                                to="parameters"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Standard Parameters
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 22 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={22}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "test-master" ? "mm-active" : ""
                                }`}
                                to="test-master"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Test Master
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 23 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={23}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "reference-standard"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="reference-standard"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Reference Standard
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 24 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={24}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "reference-standard-test-mapping"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="reference-standard-test-mapping"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Ref Standard - Test Mapping
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 82 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={82}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "mix-design-master"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="mix-design-master"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Mix Design Master");
                                }}
                              >
                                Mix Design Master
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                        </ul>
                      </Collapse>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Material Configuration */}

                  {/* START: Machine */}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      (x?.FormID == 25 || x?.FormID == 26) &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={25}
                      className={`${
                        state?.activeSubmenu === "Machine" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="has-arrow"
                        onClick={() => {
                          // handleMenuActive("Configuration");
                          handleSubmenuActive("Machine");
                        }}
                      >
                        Machine
                      </Link>
                      <Collapse
                        in={state?.activeSubmenu === "Machine" ? true : false}
                      >
                        <ul className="mm-show">
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 25 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={25}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "machines" ? "mm-active" : ""
                                }`}
                                to="machines"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Machine");
                                }}
                              >
                                Machine
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {AuthUser?.EnableMachineInterface &&
                          AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 25 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key="machine-readings"
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "machine-readings" ? "mm-active" : ""
                                }`}
                                to="machine-readings"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Machine");
                                }}
                              >
                                Machine Readings
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}

                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 26 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            AuthUser?.Permissions?.MachineMaintenance == 1 ? (
                              <li
                                key={26}
                                style={{
                                  paddingLeft: "15px",
                                  fontWeight: 300,
                                }}
                              >
                                <Link
                                  className={`${
                                    path === "machines-calibration"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="machines-calibration"
                                  onClick={() => {
                                    handleMenuActive("Configuration");
                                    handleSubmenuActive("Machine");
                                  }}
                                >
                                  Calibration
                                </Link>
                              </li>
                            ) : (
                              ""
                            )
                          ) : (
                            <></>
                          )}
                        </ul>
                      </Collapse>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Machine */}

                  {/* START: Machining Configuration */}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 16 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={16}
                      className={`${
                        state?.activeSubmenu === "Machining Configuration"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="machine-configuration-list"
                        onClick={() => {
                          handleMenuActive("Configuration");
                          handleSubmenuActive("Machining Configuration");
                        }}
                      >
                        Machining Configuration
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Machining Configuration */}

                  {/* START: Rates */}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      (x?.FormID == 48 || x?.FormID == 49) &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={48}
                      className={`${
                        state?.activeSubmenu === "Rates" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="has-arrow"
                        onClick={() => {
                          // handleMenuActive("Configuration");
                          handleSubmenuActive("Rates");
                        }}
                      >
                        Rates
                      </Link>
                      <Collapse
                        in={state?.activeSubmenu === "Rates" ? true : false}
                      >
                        <ul className="mm-show">
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.Permissions?.Account == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 48 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={48}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "test-master-rate" ? "mm-active" : ""
                                }`}
                                to="test-master-rate"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Test Master Rate
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.Permissions?.Account == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 49 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={49}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "customer-parameter-rate"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="customer-parameter-rate"
                                onClick={() => {
                                  handleMenuActive("Configuration");
                                  handleSubmenuActive("Material Configuration");
                                }}
                              >
                                Customer Wise Rates
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                        </ul>
                      </Collapse>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Rates */}
                </ul>
              </Collapse>
            </li>
          ) : (
            <></>
          )}
          {/* END: Configuration */}

          {/* START: Work Process */}
          {AuthUser?.UserType == 1 &&
          formsList?.filter(
            (x) =>
              (x?.FormID == 28 ||
                x?.FormID == 30 ||
                x?.FormID == 31 ||
                x?.FormID == 32 ||
                x?.FormID == 33 ||
                x?.FormID == 34 ||
                x?.FormID == 35 ||
                x?.FormID == 36 ||
                x?.FormID == 37 ||
                x?.FormID == 88 ||
                x?.FormID == 103 ||
                x?.FormID == 105) &&
              (x?.IsRead ||
                x?.IsAdd ||
                x?.IsEdit ||
                x?.IsActive ||
                x?.IsDelete ||
                x?.IsExport),
          )?.length > 0 ? (
            <li
              className={` ${
                state?.active === "Work Process" ? "mm-active" : ""
              }`}
              key={4}
            >
              <Link
                to={"#"}
                className="has-arrow"
                onClick={() => {
                  handleMenuActive("Work Process");
                }}
              >
                <div className="menu-icon">{SVGICON.ProjectsSidbar}</div>{" "}
                <span className="nav-text">Work Process</span>
              </Link>
              <Collapse in={state?.active === "Work Process" ? true : false}>
                <ul className="mm-show">
                  {/* START: Inward */}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.LicenseTypeID != 5 &&
                  AuthUser?.Permissions?.DT == 1 &&
                  formsList?.filter(
                    (x) =>
                      (x?.FormID == 31 || x?.FormID == 32) &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={27}
                      className={`${
                        state?.activeSubmenu === "Inward" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="has-arrow"
                        onClick={() => {
                          handleSubmenuActive("Inward");
                          // handleMenuActive("Work Process");
                        }}
                      >
                        Inward
                      </Link>
                      <Collapse
                        in={state?.activeSubmenu === "Inward" ? true : false}
                      >
                        <ul className="mm-show">
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.LicenseTypeID != 5 &&
                          AuthUser?.Permissions?.DT == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 31 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={31}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "material-inward" ? "mm-active" : ""
                                }`}
                                to="material-inward"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Inward");
                                }}
                              >
                                Material Inward
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.LicenseTypeID != 5 &&
                          AuthUser?.Permissions?.DT == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 32 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={32}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "tc-test-allocation-list"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="tc-test-allocation-list"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Inward");
                                }}
                              >
                                TC / Test Allocation
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                        </ul>
                      </Collapse>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Inward */}

                  {AuthUser?.UserType == 1 &&
                    AuthUser?.LicenseTypeID != 5 &&
                    AuthUser?.Permissions?.NDT == 1 &&
                    formsList?.filter(
                      (x) =>
                        x?.FormID == 103 &&
                        (x?.IsRead ||
                          x?.IsAdd ||
                          x?.IsEdit ||
                          x?.IsActive ||
                          x?.IsDelete ||
                          x?.IsExport),
                    )?.length > 0 && (
                      <li
                        key={103}
                        className={`${
                          state?.activeSubmenu === "NDT Inward"
                            ? "mm-active"
                            : ""
                        }`}
                      >
                        <Link
                          to="ndt-material-inward"
                          onClick={() => {
                            handleSubmenuActive("NDT Inward");
                            handleMenuActive("Work Process");
                          }}
                        >
                          NDT Inward
                        </Link>
                      </li>
                    )}

                  {AuthUser?.UserType == 1 &&
                    AuthUser?.LicenseTypeID != 5 &&
                    AuthUser?.Permissions?.FoodTesting == 1 &&
                    formsList?.filter(
                      (x) =>
                        x?.FormID == 105 &&
                        (x?.IsRead ||
                          x?.IsAdd ||
                          x?.IsEdit ||
                          x?.IsActive ||
                          x?.IsDelete ||
                          x?.IsExport),
                    )?.length > 0 && (
                      <li
                        key={105}
                        className={`${
                          state?.activeSubmenu === "Food Testing Inward"
                            ? "mm-active"
                            : ""
                        }`}
                      >
                        <Link
                          to="ft-material-inward"
                          onClick={() => {
                            handleSubmenuActive("Food Testing Inward");
                            handleMenuActive("Work Process");
                          }}
                        >
                          Food Testing Inward
                        </Link>
                      </li>
                    )}

                  {/* START: Machining Outward */}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.LicenseTypeID != 5 &&
                  AuthUser?.Permissions?.Machining == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 28 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={28}
                      className={`${
                        state?.activeSubmenu === "Machining Outward"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="machining-outward-list"
                        onClick={() => {
                          handleSubmenuActive("Machining Outward");
                          handleMenuActive("Work Process");
                        }}
                      >
                        Machining Outward
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Machining Outward */}

                  {/* START: Operation */}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      (x?.FormID == 33 ||
                        x?.FormID == 34 ||
                        x?.FormID == 35 ||
                        x?.FormID == 36 ||
                        x?.FormID == 37) &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={29}
                      className={`${
                        state?.activeSubmenu === "Operation" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="has-arrow"
                        onClick={() => {
                          handleSubmenuActive("Operation");
                          // handleMenuActive("Work Process");
                        }}
                      >
                        Operation
                      </Link>
                      <Collapse
                        in={state?.activeSubmenu === "Operation" ? true : false}
                      >
                        <ul className="mm-show">
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.LicenseTypeID != 5 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 33 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={33}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "testing-list" ? "mm-active" : ""
                                }`}
                                to="testing-list"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Operation");
                                }}
                              >
                                Testing
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 34 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={34}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "report-printing-list"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="report-printing-list"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Operation");
                                }}
                              >
                                Report Printing
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.Permissions?.DispatchReport == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 35 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={35}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "report-dispatch-list"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="report-dispatch-list"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Operation");
                                }}
                              >
                                Dispatch Report
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.Permissions?.DispatchMaterial == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 36 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={36}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "material-dispatch-list"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="material-dispatch-list"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Operation");
                                }}
                              >
                                Dispatch Material
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.Permissions?.UploadScanCopy == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 37 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsActive ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={37}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "upload-scan-copy-list"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="upload-scan-copy-list"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Operation");
                                }}
                              >
                                Upload Scan Copy
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.Permissions?.FoodTesting == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 106 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={106}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "sample-return-to-returner-list"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="sample-return-to-returner-list"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Operation");
                                }}
                              >
                                Sample Return To Returner
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {AuthUser?.UserType == 1 &&
                          AuthUser?.Permissions?.FoodTesting == 1 &&
                          formsList?.filter(
                            (x) =>
                              x?.FormID == 107 &&
                              (x?.IsRead ||
                                x?.IsAdd ||
                                x?.IsEdit ||
                                x?.IsDelete ||
                                x?.IsExport),
                          )?.length > 0 ? (
                            <li
                              key={107}
                              style={{
                                paddingLeft: "15px",
                                fontWeight: 300,
                              }}
                            >
                              <Link
                                className={`${
                                  path === "sample-dispose-list"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="sample-dispose-list"
                                onClick={() => {
                                  handleMenuActive("Work Process");
                                  handleSubmenuActive("Operation");
                                }}
                              >
                                Sample Dispose
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                        </ul>
                      </Collapse>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Operation */}

                  {/* START: Reports */}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 30 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={30}
                      className={`${
                        state?.activeSubmenu === "Reports" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="reports"
                        onClick={() => {
                          handleSubmenuActive("Reports");
                          handleMenuActive("Work Process");
                        }}
                      >
                        Reports
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Reports */}

                  {/* START: Sample Preparation & Testing */}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.LicenseTypeID == 5 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 88 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={88}
                      className={`${
                        state?.activeSubmenu === "Sample Preparation & Testing"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="sample-preparation-and-testing"
                        onClick={() => {
                          handleSubmenuActive("Sample Preparation & Testing");
                          handleMenuActive("Work Process");
                        }}
                      >
                        Sample Preparation & Testing
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* END: Sample Preparation & Testing */}
                </ul>
              </Collapse>
            </li>
          ) : (
            <></>
          )}
          {/* END: Work Process */}

          {/* START: Account */}
          {AuthUser?.UserType == 1 &&
          AuthUser?.Permissions?.Account == 1 &&
          formsList?.filter(
            (x) =>
              (x?.FormID == 51 ||
                x?.FormID == 52 ||
                x?.FormID == 53 ||
                x?.FormID == 54 ||
                x?.FormID == 55 ||
                x?.FormID == 57 ||
                x?.FormID == 58 ||
                x?.FormID == 59 ||
                x?.FormID == 60 ||
                x?.FormID == 62 ||
                x?.FormID == 63) &&
              (x?.IsRead ||
                x?.IsAdd ||
                x?.IsEdit ||
                x?.IsActive ||
                x?.IsDelete ||
                x?.IsExport),
          )?.length > 0 ? (
            <li
              className={` ${state?.active === "Account" ? "mm-active" : ""}`}
              key={50}
            >
              <Link
                to={"#"}
                className="has-arrow"
                onClick={() => {
                  handleMenuActive("Account");
                }}
              >
                <div className="menu-icon">{SVGICON.Finance}</div>{" "}
                <span className="nav-text">Account</span>
              </Link>
              <Collapse in={state?.active === "Account" ? true : false}>
                <ul className="mm-show">
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 51 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={51}
                      className={`${
                        state?.activeSubmenu === "Proforma Invoice"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/proforma-invoice"
                        onClick={() => {
                          handleSubmenuActive("Proforma Invoice");
                          handleMenuActive("Account");
                        }}
                      >
                        Proforma Invoice
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 52 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={52}
                      className={`${
                        state?.activeSubmenu === "Invoice" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="/invoice"
                        onClick={() => {
                          handleSubmenuActive("Invoice");
                          handleMenuActive("Account");
                        }}
                      >
                        Invoice
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 54 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={54}
                      className={`${
                        state?.activeSubmenu === "Advance Receipt"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/advance-receipt"
                        onClick={() => {
                          handleSubmenuActive("Advance Receipt");
                          handleMenuActive("Account");
                        }}
                      >
                        Advance Receipt
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 55 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={55}
                      className={`${
                        state?.activeSubmenu === "Payment Receipt"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/payment-receipt"
                        onClick={() => {
                          handleSubmenuActive("Payment Receipt");
                          handleMenuActive("Account");
                        }}
                      >
                        Payment Receipt
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 63 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={63}
                      className={`${
                        state?.activeSubmenu === "Credit Note"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/credit-note"
                        onClick={() => {
                          handleSubmenuActive("Credit Note");
                          handleMenuActive("Account");
                        }}
                      >
                        Credit Note
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {/* START: Reports */}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      (x?.FormID == 57 ||
                        x?.FormID == 58 ||
                        x?.FormID == 59 ||
                        x?.FormID == 60 ||
                        x?.FormID == 62) &&
                      (x?.IsRead || x?.IsExport),
                  )?.length > 0 ? (
                    <>
                      {formsList?.filter(
                        (x) =>
                          (x?.FormID == 51 ||
                            x?.FormID == 52 ||
                            x?.FormID == 54 ||
                            x?.FormID == 55) &&
                          (x?.IsRead ||
                            x?.IsAdd ||
                            x?.IsEdit ||
                            x?.IsActive ||
                            x?.IsDelete ||
                            x?.IsExport),
                      )?.length > 0 && (
                        <hr className="mt-0" style={{ opacity: 0.1 }}></hr>
                      )}

                      <li
                        key={27}
                        className={`${
                          state?.activeSubmenu === "Reports" ? "mm-active" : ""
                        }`}
                      >
                        <Link
                          to="#"
                          className="has-arrow"
                          onClick={() => {
                            handleSubmenuActive("Reports");
                            // handleMenuActive("Account");
                          }}
                        >
                          Reports
                        </Link>
                        <Collapse
                          in={state?.activeSubmenu === "Reports" ? true : false}
                        >
                          <ul className="mm-show">
                            {AuthUser?.UserType == 1 &&
                            AuthUser?.Permissions?.Account == 1 &&
                            formsList?.filter(
                              (x) =>
                                x?.FormID == 57 && (x?.IsRead || x?.IsExport),
                            )?.length > 0 ? (
                              <li
                                key={57}
                                style={{
                                  paddingLeft: "15px",
                                  fontWeight: 300,
                                }}
                              >
                                <Link
                                  className={`${
                                    path === "outstanding-report"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="outstanding-report"
                                  onClick={() => {
                                    handleMenuActive("Account");
                                    handleSubmenuActive("Reports");
                                  }}
                                >
                                  Outstanding Report
                                </Link>
                              </li>
                            ) : (
                              <></>
                            )}
                            {AuthUser?.UserType == 1 &&
                            AuthUser?.Permissions?.Account == 1 &&
                            formsList?.filter(
                              (x) =>
                                x?.FormID == 58 && (x?.IsRead || x?.IsExport),
                            )?.length > 0 ? (
                              <li
                                key={58}
                                style={{
                                  paddingLeft: "15px",
                                  fontWeight: 300,
                                }}
                              >
                                <Link
                                  className={`${
                                    path === "invoice-register"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="invoice-register"
                                  onClick={() => {
                                    handleMenuActive("Account");
                                    handleSubmenuActive("Reports");
                                  }}
                                >
                                  Invoice Register
                                </Link>
                              </li>
                            ) : (
                              <></>
                            )}
                            {AuthUser?.UserType == 1 &&
                            AuthUser?.Permissions?.Account == 1 &&
                            formsList?.filter(
                              (x) =>
                                x?.FormID == 59 && (x?.IsRead || x?.IsExport),
                            )?.length > 0 ? (
                              <li
                                key={59}
                                style={{
                                  paddingLeft: "15px",
                                  fontWeight: 300,
                                }}
                              >
                                <Link
                                  className={`${
                                    path === "pending-invoice"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="pending-invoice"
                                  onClick={() => {
                                    handleMenuActive("Account");
                                    handleSubmenuActive("Reports");
                                  }}
                                >
                                  Pending Invoice
                                </Link>
                              </li>
                            ) : (
                              <></>
                            )}
                            {AuthUser?.UserType == 1 &&
                            AuthUser?.Permissions?.Account == 1 &&
                            formsList?.filter(
                              (x) =>
                                x?.FormID == 60 && (x?.IsRead || x?.IsExport),
                            )?.length > 0 ? (
                              <li
                                key={60}
                                style={{
                                  paddingLeft: "15px",
                                  fontWeight: 300,
                                }}
                              >
                                <Link
                                  className={`${
                                    path === "payment-receipt-register"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="payment-receipt-register"
                                  onClick={() => {
                                    handleMenuActive("Account");
                                    handleSubmenuActive("Reports");
                                  }}
                                >
                                  Payment Receipt Register
                                </Link>
                              </li>
                            ) : (
                              <></>
                            )}
                            {AuthUser?.UserType == 1 &&
                            AuthUser?.Permissions?.Account == 1 &&
                            formsList?.filter(
                              (x) =>
                                x?.FormID == 62 && (x?.IsRead || x?.IsExport),
                            )?.length > 0 ? (
                              <li
                                key={62}
                                style={{
                                  paddingLeft: "15px",
                                  fontWeight: 300,
                                }}
                              >
                                <Link
                                  className={`${
                                    path === "ledger-report" ? "mm-active" : ""
                                  }`}
                                  to="ledger-report"
                                  onClick={() => {
                                    handleMenuActive("Account");
                                    handleSubmenuActive("Reports");
                                  }}
                                >
                                  Ledger Report
                                </Link>
                              </li>
                            ) : (
                              <></>
                            )}
                          </ul>
                        </Collapse>
                      </li>

                      {formsList?.filter(
                        (x) =>
                          x?.FormID == 53 &&
                          (x?.IsRead ||
                            x?.IsAdd ||
                            x?.IsEdit ||
                            x?.IsActive ||
                            x?.IsDelete ||
                            x?.IsExport),
                      )?.length > 0 && (
                        <hr className="mt-0" style={{ opacity: 0.1 }}></hr>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  {/* END: Inward */}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Account == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 53 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={53}
                      className={`${
                        state?.activeSubmenu === "Expenses" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="/expenses"
                        onClick={() => {
                          handleSubmenuActive("Expenses");
                          handleMenuActive("Account");
                        }}
                      >
                        Expenses
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                </ul>
              </Collapse>
            </li>
          ) : (
            <></>
          )}
          {/* END: Account */}

          {/* START: Utility */}
          {AuthUser?.UserType == 1 &&
          formsList?.filter(
            (x) =>
              (x?.FormID == 38 ||
                x?.FormID == 39 ||
                x?.FormID == 40 ||
                x?.FormID == 46 ||
                x?.FormID == 79 ||
                x?.FormID == 80) &&
              (x?.IsRead ||
                x?.IsAdd ||
                x?.IsEdit ||
                x?.IsActive ||
                x?.IsDelete ||
                x?.IsExport),
          )?.length > 0 ? (
            <li
              className={` ${state?.active === "Utility" ? "mm-active" : ""}`}
              key={5}
            >
              <Link
                to={"#"}
                className="has-arrow"
                onClick={() => {
                  handleMenuActive("Utility");
                }}
              >
                <div className="menu-icon">{SVGICON.GridDots}</div>{" "}
                <span className="nav-text">Utility</span>
              </Link>
              <Collapse in={state?.active === "Utility" ? true : false}>
                <ul className="mm-show">
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 38 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={38}
                      className={`${
                        state?.activeSubmenu === "Print Label"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/print-label"
                        onClick={() => {
                          handleSubmenuActive("Print Label");
                          handleMenuActive("Utility");
                        }}
                      >
                        Print Label
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Email == 1 &&
                  formsList?.filter((x) => x?.FormID == 39 && x?.IsRead)
                    ?.length > 0 ? (
                    <li
                      key={39}
                      className={`${
                        state?.activeSubmenu === "Broadcast Message"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/broadcast-message"
                        onClick={() => {
                          handleSubmenuActive("Broadcast Message");
                          handleMenuActive("Utility");
                        }}
                      >
                        Broadcast Message
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {/* {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 40 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport)
                  )?.length > 0 ? (
                    <li
                      key={40}
                      className={`${
                        state?.activeSubmenu === "Reference Standard Directory"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="#"
                        onClick={() => {
                          handleSubmenuActive("Reference Standard Directory");
                          handleMenuActive("Utility");
                        }}
                      >
                        Reference Standard Directory
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )} */}
                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 46 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <>
                      <li
                        key={46}
                        className={`${
                          state?.activeSubmenu === "Master Data Import"
                            ? "mm-active"
                            : ""
                        }`}
                      >
                        <Link
                          to="master-data-import"
                          onClick={() => {
                            handleSubmenuActive("Master Data Import");
                            handleMenuActive("Utility");
                          }}
                        >
                          Master Data Import
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Email == 1 &&
                  formsList?.filter(
                    (x) => x?.FormID == 79 && (x?.IsRead || x?.IsEdit),
                  )?.length > 0 ? (
                    <>
                      <li
                        key={79}
                        className={`${
                          state?.activeSubmenu === "Email Templates Edit"
                            ? "mm-active"
                            : ""
                        }`}
                      >
                        <Link
                          to="email-templates-edit"
                          onClick={() => {
                            handleSubmenuActive("Email Templates Edit");
                            handleMenuActive("Utility");
                          }}
                        >
                          Email Templates
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.TestResultFromFile == 1 &&
                  formsList?.filter((x) => x?.FormID == 80 && x?.IsAdd)
                    ?.length > 0 ? (
                    <>
                      <li
                        key={80}
                        className={`${
                          state?.activeSubmenu ===
                          "Machine Result CSV File Import"
                            ? "mm-active"
                            : ""
                        }`}
                      >
                        <Link
                          to="machine-result-csv-file-import"
                          onClick={() => {
                            handleSubmenuActive(
                              "Machine Result CSV File Import",
                            );
                            handleMenuActive("Utility");
                          }}
                        >
                          Machine Result CSV File Import
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 85 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <>
                      <li
                        key={85}
                        className={`${
                          state?.activeSubmenu === "Update Scope"
                            ? "mm-active"
                            : ""
                        }`}
                      >
                        <Link
                          to="update-scope"
                          onClick={() => {
                            handleSubmenuActive("Update Scope");
                            handleMenuActive("Utility");
                          }}
                        >
                          Update Scope
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 87 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete),
                  )?.length > 0 ? (
                    <>
                      <li
                        key={87}
                        className={`${
                          state?.activeSubmenu === "Document Management"
                            ? "mm-active"
                            : ""
                        }`}
                      >
                        <Link
                          to="document-management"
                          onClick={() => {
                            handleSubmenuActive("Document Management");
                            handleMenuActive("Utility");
                          }}
                        >
                          Document Management
                        </Link>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                </ul>
              </Collapse>
            </li>
          ) : (
            <></>
          )}
          {/* END: Utility */}

          {/* START: Inventory  */}
          {AuthUser?.UserType == 1 &&
          AuthUser?.Permissions?.Inventory == 1 &&
          formsList?.filter(
            (x) =>
              (x?.FormID == 90 ||
                x?.FormID == 91 ||
                x?.FormID == 92 ||
                x?.FormID == 98 ||
                x?.FormID == 99 ||
                x?.FormID == 93) &&
              (x?.IsRead ||
                x?.IsAdd ||
                x?.IsEdit ||
                x?.IsActive ||
                x?.IsDelete ||
                x?.IsExport),
          )?.length > 0 ? (
            <li
              className={` ${state?.active === "Inventory" ? "mm-active" : ""}`}
              key={89}
            >
              <Link
                to={"#"}
                className="has-arrow"
                onClick={() => {
                  handleMenuActive("Inventory");
                }}
              >
                <div className="menu-icon">{SVGICON.Inventory}</div>{" "}
                <span className="nav-text">Inventory</span>
              </Link>
              <Collapse in={state?.active === "Inventory" ? true : false}>
                <ul className="mm-show">
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Inventory == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 90 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={90}
                      className={`${
                        state?.activeSubmenu === "Items" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="/items"
                        onClick={() => {
                          handleSubmenuActive("Items");
                          handleMenuActive("Inventory");
                        }}
                      >
                        Items
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Inventory == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 91 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={91}
                      className={`${
                        state?.activeSubmenu === "Goods Receipt Note"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/grn"
                        onClick={() => {
                          handleSubmenuActive("Goods Receipt Note");
                          handleMenuActive("Inventory");
                        }}
                      >
                        Goods Receipt Note
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Inventory == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 92 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={92}
                      className={`${
                        state?.activeSubmenu === "Item Issue" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="/item-issue"
                        onClick={() => {
                          handleSubmenuActive("Item Issue");
                          handleMenuActive("Inventory");
                        }}
                      >
                        Item Issue
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Inventory == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 93 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={93}
                      className={`${
                        state?.activeSubmenu === "Item Return"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/item-return"
                        onClick={() => {
                          handleSubmenuActive("Item Return");
                          handleMenuActive("Inventory");
                        }}
                      >
                        Item Return
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Inventory == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 98 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={98}
                      className={`${
                        state?.activeSubmenu === "Item Wastage"
                          ? "mm-active"
                          : ""
                      }`}
                    >
                      <Link
                        to="/item-wastage"
                        onClick={() => {
                          handleSubmenuActive("Item Wastage");
                          handleMenuActive("Inventory");
                        }}
                      >
                        Item Wastage
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Inventory == 1 &&
                  formsList?.filter(
                    (x) =>
                      x?.FormID == 99 &&
                      (x?.IsRead ||
                        x?.IsAdd ||
                        x?.IsEdit ||
                        x?.IsActive ||
                        x?.IsDelete ||
                        x?.IsExport),
                  )?.length > 0 ? (
                    <li
                      key={99}
                      className={`${
                        state?.activeSubmenu === "Item DC" ? "mm-active" : ""
                      }`}
                    >
                      <Link
                        to="/item-dc"
                        onClick={() => {
                          handleSubmenuActive("Item DC");
                          handleMenuActive("Inventory");
                        }}
                      >
                        Item DC
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )}

                  {/* START: Reports */}
                  {AuthUser?.UserType == 1 &&
                  AuthUser?.Permissions?.Inventory == 1 &&
                  formsList?.filter(
                    (x) =>
                      (x?.FormID == 101 || x?.FormID == 102) &&
                      (x?.IsRead || x?.IsExport),
                  )?.length > 0 ? (
                    <>
                      {formsList?.filter(
                        (x) =>
                          (x?.FormID == 101 || x?.FormID == 102) &&
                          (x?.IsRead || x?.IsExport),
                      )?.length > 0 && (
                        <hr className="mt-0" style={{ opacity: 0.1 }}></hr>
                      )}

                      <li
                        key={100}
                        className={`${
                          state?.activeSubmenu === "Reports" ? "mm-active" : ""
                        }`}
                      >
                        <Link
                          to="#"
                          className="has-arrow"
                          onClick={() => {
                            handleSubmenuActive("Reports");
                          }}
                        >
                          Reports
                        </Link>
                        <Collapse
                          in={state?.activeSubmenu === "Reports" ? true : false}
                        >
                          <ul className="mm-show">
                            {AuthUser?.UserType == 1 &&
                            AuthUser?.Permissions?.Inventory == 1 &&
                            formsList?.filter(
                              (x) =>
                                x?.FormID == 101 && (x?.IsRead || x?.IsExport),
                            )?.length > 0 ? (
                              <li
                                key={101}
                                style={{
                                  paddingLeft: "15px",
                                  fontWeight: 300,
                                }}
                              >
                                <Link
                                  className={`${
                                    path === "item-stock-register"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="item-stock-register"
                                  onClick={() => {
                                    handleMenuActive("Inventory");
                                    handleSubmenuActive("Reports");
                                  }}
                                >
                                  Item Stock Register
                                </Link>
                              </li>
                            ) : (
                              <></>
                            )}

                            {AuthUser?.UserType == 1 &&
                            AuthUser?.Permissions?.Inventory == 1 &&
                            formsList?.filter(
                              (x) =>
                                x?.FormID == 102 && (x?.IsRead || x?.IsExport),
                            )?.length > 0 ? (
                              <li
                                key={102}
                                style={{
                                  paddingLeft: "15px",
                                  fontWeight: 300,
                                }}
                              >
                                <Link
                                  className={`${
                                    path === "item-issue-in-out"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="item-issue-in-out"
                                  onClick={() => {
                                    handleMenuActive("Inventory");
                                    handleSubmenuActive("Reports");
                                  }}
                                >
                                  Item Issue In/Out
                                </Link>
                              </li>
                            ) : (
                              <></>
                            )}
                          </ul>
                        </Collapse>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                  {/* END: Reports */}
                </ul>
              </Collapse>
            </li>
          ) : (
            <></>
          )}
          {/* END: Inventory  */}
        </ul>

        {/*START: Shortcut buttons*/}
        <div className="pe-1" style={{ float: "right" }}>
          <ul className="metismenu p-0 metismenuRight" id="menu">
            {AuthUser?.UserType == 1 &&
            AuthUser?.LicenseTypeID != 5 &&
            AuthUser?.Permissions?.DT == 1 &&
            formsList?.filter(
              (x) =>
                x?.FormID == 31 &&
                (x?.IsRead ||
                  x?.IsAdd ||
                  x?.IsEdit ||
                  x?.IsActive ||
                  x?.IsDelete ||
                  x?.IsExport),
            )?.length > 0 ? (
              <li key={31}>
                <Link to="material-inward" title="Go to Material Inward">
                  <div className="menu-icon">{SVGICON.Inward}</div>
                </Link>
              </li>
            ) : (
              <></>
            )}
            {AuthUser?.UserType == 1 &&
            AuthUser?.LicenseTypeID != 5 &&
            AuthUser?.Permissions?.NDT == 1 &&
            AuthUser?.Permissions?.DT != 1 &&
            AuthUser?.Permissions?.FoodTesting != 1 &&
            formsList?.filter(
              (x) =>
                x?.FormID == 103 &&
                (x?.IsRead ||
                  x?.IsAdd ||
                  x?.IsEdit ||
                  x?.IsActive ||
                  x?.IsDelete ||
                  x?.IsExport),
            )?.length > 0 ? (
              <li key={103}>
                <Link to="ndt-material-inward" title="Go to NDT Inward">
                  <div className="menu-icon">{SVGICON.Inward}</div>
                </Link>
              </li>
            ) : (
              <></>
            )}
            {AuthUser?.UserType == 1 &&
            AuthUser?.LicenseTypeID != 5 &&
            AuthUser?.Permissions?.FoodTesting == 1 &&
            AuthUser?.Permissions?.DT != 1 &&
            AuthUser?.Permissions?.NDT != 1 &&
            formsList?.filter(
              (x) =>
                x?.FormID == 105 &&
                (x?.IsRead ||
                  x?.IsAdd ||
                  x?.IsEdit ||
                  x?.IsActive ||
                  x?.IsDelete ||
                  x?.IsExport),
            )?.length > 0 ? (
              <li key={105}>
                <Link to="ft-material-inward" title="Go to Food Testing Inward">
                  <div className="menu-icon">{SVGICON.Inward}</div>
                </Link>
              </li>
            ) : (
              <></>
            )}
            {AuthUser?.UserType == 1 &&
              AuthUser?.LicenseTypeID == 5 &&
              formsList?.filter(
                (x) =>
                  x?.FormID == 88 &&
                  (x?.IsRead ||
                    x?.IsAdd ||
                    x?.IsEdit ||
                    x?.IsActive ||
                    x?.IsDelete ||
                    x?.IsExport),
              )?.length > 0 && (
                <li key={88}>
                  <Link
                    to="sample-preparation-and-testing"
                    title="Go to Sample Preparation & Testing"
                  >
                    <div className="menu-icon">{SVGICON.Inward}</div>
                  </Link>
                </li>
              )}
            {AuthUser?.UserType == 1 &&
            AuthUser?.LicenseTypeID != 5 &&
            formsList?.filter(
              (x) =>
                x?.FormID == 33 &&
                (x?.IsRead ||
                  x?.IsAdd ||
                  x?.IsEdit ||
                  x?.IsActive ||
                  x?.IsDelete ||
                  x?.IsExport),
            )?.length > 0 ? (
              <li key={33}>
                <Link to="testing-list" title="Go to Testing">
                  <div className="menu-icon">{SVGICON.Testing}</div>
                </Link>
              </li>
            ) : (
              <></>
            )}
            {AuthUser?.UserType == 1 &&
            formsList?.filter(
              (x) =>
                x?.FormID == 34 &&
                (x?.IsRead ||
                  x?.IsAdd ||
                  x?.IsEdit ||
                  x?.IsActive ||
                  x?.IsDelete ||
                  x?.IsExport),
            )?.length > 0 ? (
              <li key={34}>
                <Link to="report-printing-list" title="Go to Report Printing">
                  <div className="menu-icon">{SVGICON.Reporting}</div>
                </Link>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
        {/*END: Shortcut buttons*/}
      </div>
    </div>
  );
};

export default SideBarLIMS;
